import { GetStaticPaths, GetStaticProps } from 'next'
import uniqBy from 'lodash.uniqby'

import query, { PAGES } from './queries'
import ROUTE from './route'

import initApollo, { API } from 'src/api'

export const getStaticPaths: GetStaticPaths = async () => {
  const client = initApollo({})

  const { data } = await client.query<API.HelpCenterTopic_pages>({
    query: PAGES,
  })

  const paths = data.helpCenterTopics?.map((item) => ROUTE.path({ topicSlug: item.slug })) || []

  return { paths, fallback: false }
}

export type Props = API.HelpCenterTopic & { topicSlug?: string | null }

export const getStaticProps: GetStaticProps<Props, { topicSlug?: string }> = async ({ params }) => {
  const client = initApollo({})

  const { data } = await client.query<API.HelpCenterTopic, API.HelpCenterTopicVariables>({
    query,
    variables: {
      topicSlug: params?.topicSlug,
      topicType: params?.topicSlug ? undefined : API.HelpCenterTopicType.NORMAL,
    },
  })

  return {
    props: {
      ...data,
      // NOTE: There is a bug in the API that duplicates the articles
      // so we are filtering them here
      helpCenterArticles: {
        __typename: 'HelpCenterArticleList',
        nodes: uniqBy(data.helpCenterArticles?.nodes, 'id'),
      },
      topicSlug: params?.topicSlug || null,
    },
  }
}
